/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "Skewing in costume editor",
  "description": "Hold Ctrl while scaling an object on its sides to skew it. Hold Alt while skewing an object to skew it from its center.",
  "credits": [
    {
      "name": "CST1229",
      "link": "https://github.com/CST1229/"
    }
  ],
  "tags": ["editor", "costumeEditor", "new", "recommended"],
  "userscripts": [
    {
      "url": "userscript.js",
      "matches": ["projects"]
    }
  ],
  "versionAdded": "1.30.0",
  "dynamicEnable": true,
  "dynamicDisable": true,
  "enabledByDefault": true
};
export default manifest;
